import { useState, useMemo } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import classNames from 'classnames';
import type { ResourceHistoryItem } from '../../../shared/types';

interface VersionHistoryProps {
  versions?: ResourceHistoryItem[] | null;
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const VersionHistory = ({ versions }: VersionHistoryProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const sortedVersions = useMemo(
    () =>
      [...(versions || [])]
        .filter((v) => v.createdAt)
        .sort((a, b) => new Date(b.createdAt!).getTime() - new Date(a.createdAt!).getTime()),
    [versions],
  );

  if (!sortedVersions.length) {
    return null;
  }

  return (
    <div className="mt-sh-30 border-t border-people-gray-200 pt-[16px]">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between font-haffer text-sh-12-18 font-bold text-gray-700 hover:text-gray-900">
        <span className="mr-[6px]">Version history</span>
        {isExpanded ? <ChevronUp size={24} color="#E3786D" /> : <ChevronDown size={24} color="#E3786D" />}
      </button>

      {isExpanded && (
        <div className="mt-[10px] space-y-2">
          {sortedVersions.map((version, index) => (
            <div
              key={version.documentId}
              className={classNames('flex items-center gap-2 font-haffer text-sh-12-18', {
                'font-medium text-black': index === 0,
                'text-black': index !== 0,
              })}>
              <span>
                Version {version.version} {index === 0 ? '(Current)' : ''}
              </span>
              <span>
                {index === 0 ? 'Published on' : 'Updated on'} {formatDate(version.createdAt!)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
